import React, { useEffect, useState } from 'react'
import { actionPermission, errorSchema, utils } from 'helper'
import { CityDropdownForTrip, CommonModal, CustomSelect } from 'components'
import StorageService from 'utils/StorageServices/StorageServices'
import { getConsignorDropdownListData } from '_services/dropdownServices/dropdownService'
import { fetchConsignorDetailsData, getConsignorListData } from '_services/accountsServices/consignorServices'
import EbillExtentionModal from 'modals/EbillExtentionModal'
import { constant } from 'constants/constant';
import toast from 'react-hot-toast'

const formObj = {
    party: {},
}

const AddLrModal = (props) => {
    let { nextModal, closeModal, addButtonAction, showPrefield, secondSubmit, isAddLrLater, filledLocation = {}, submitTitle, branchFirmIdForTrip = {} } = props;

    const [formValue, setFormValue] = useState(formObj);
    const [formError, setFormError] = useState({});
    const [loading, setLoading] = useState(false);
    const [consignorList, setConsignorList] = useState([]);
    const [modalConfig, setModalConfig] = useState({
        isOpen: false,
        messageType: null,
        templateId: null,
        templateData: {}
    });

    const getDropdownDataConsignorList = async () => {
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
                firm_id: branchFirmIdForTrip?._id ? branchFirmIdForTrip?._id : StorageService.getFirmId(),
                limit: 100,
                offset: 1,
                search: '',
            }
            const res = await getConsignorDropdownListData(object);
            setLoading(false);
            if (res?.responseCode == 200) {
                setConsignorList(res?.data?.consignor_list)
            }
        } catch (error) {
            // throw error;
        }
    }

    const fetchConsignor = async (search, page, limit) => {
        setLoading(true);
        const res = await getConsignorListData({
            company_id: StorageService.getCompanyId(),
            firm_id: branchFirmIdForTrip?._id ? branchFirmIdForTrip?._id : StorageService.getFirmId(),
            offset: page,
            limit,
            search,
        });

        if (res?.responseCode === 200) {

            const list = await res?.data?.consignor_list?.map((el) => ({
                ...el, label: el?.name,
                value: el?._id,
                consignor_code: el?.consignor_code,
                template_no: el?.template_no,
            }))

            if(list.length ==1){
                setFormValue((f)=>({...f,party:list[0]}))
            }

            setLoading(false);
            return {
                items: list,
                total: res?.data?.total_record,
            };

        } else {
            setLoading(false);
            toast.error(res?.responseMessage);
        }
    };

    useEffect(() => {
        setLoading(true);
        getDropdownDataConsignorList();
    }, [])

    const onhandleSelect = async (item, name) => {
        const stateObj = { ...formValue, [name]: item };
        setFormValue(stateObj);

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, errorSchema.createLrModalSchema);
            if (validationResult === true) {
                setFormError({});
            } else {
                setFormError(validationResult);
            }
        }
    };

    const apiCallingFunction = async () => {
        try {
            let object = {
                consignor_id: formValue?.party?.value,
                company_id: StorageService.getCompanyId(),
            }
            const res = await fetchConsignorDetailsData(object);
            if (!!res) {
                nextModal(res?.data?.consignor);
                closeModal(false);
                setFormValue({});
                setLoading(false);
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const handlePermissionCall = async (e) => {
        e.preventDefault();
        const validationResult = await utils?.checkFormError(formValue, errorSchema.createLrModalSchema);
        if (utils?.isObjectKeyEmpty(validationResult)) {
            await actionPermission({
                company_id: StorageService.getCompanyId(),
                type: constant?.USABILITY_CONFIG_TYPES?.LR,
                onSuccess: () => handleSubmit(e),
                setModalConfig
            });
        } else {
            setFormError(validationResult);

        }


    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const validationResult = await utils?.checkFormError(formValue, errorSchema.createLrModalSchema);
        if (utils?.isObjectKeyEmpty(validationResult)) {
            setLoading(true);
            apiCallingFunction()
            setFormError("");
        } else {
            setFormError(validationResult);
            setLoading(false);
        }
    }

    const handleSubmitWithOutLr = async (event) => {
        event.preventDefault();
        const validationResult = await utils?.checkFormError(formValue, errorSchema.createLrModalSchema);
        if (utils?.isObjectKeyEmpty(validationResult)) {
            secondSubmit(formValue)
        } else {
            setFormError(validationResult);
            setLoading(false);
        }
    }


    const propsLrModalInhance = {
        ...props,
        isLoadding: loading,
        disabled: loading,
        onSubmit: (e) => submitTitle == "Select LR" ? handleSubmit(e) : handlePermissionCall(e),
        secondSubmit: props?.modalTitle != "Edit LR" ? handleSubmitWithOutLr : false,
        isAddLrLater: isAddLrLater,
        filledLocation: filledLocation
    }

    useEffect(() => {
        if (consignorList?.length > 0 && showPrefield) {
            setFormValue((s) => ({
                ...s,
                party: consignorList?.map((el) => {
                    return {
                        label: el?.name,
                        value: el?._id,
                    }
                })[0],
            }))
        }
    }, [consignorList, showPrefield])

    const buttonActionHandler = () => {
        addButtonAction(true);
        closeModal(false)
    }

    let ebillExpProps = {
        isOpen: modalConfig.isOpen,
        closeModal: () => setModalConfig(prev => ({ ...prev, isOpen: false })),
        onSubmit: (e) => setModalConfig(prev => ({ ...prev, isOpen: false })),
        modalMainClass: " _dashCommon_Modal __actionPermissionModal _smModal",
        headerPart: true,
        floatCrossBtn: true,
        submitTitle: "Send Enquiry",
        messageType: modalConfig.messageType,
        templateId: modalConfig.templateId,
        templateData: modalConfig.templateData
    };

    return (
        <div>
            <CommonModal {...propsLrModalInhance}>
                <div className='addLr_body'>
                    {/* <CustomSelect
                        options={consignorList?.map((el) => {
                            return {
                                label: el?.name,
                                value: el?._id,
                                consignor_code: el?.consignor_code,
                                template_no: el?.template_no,
                            }
                        })}
                        name="party"
                        label="Select Party"
                        placeholder="Select Party"
                        isAddButton={true}
                        addButtonAction={(e) => buttonActionHandler(e)}
                        value={formValue?.party?.value ? formValue?.party : {}}
                        error={formError["party.label"]}
                        // error={!!(typeof formError === "object") ? formError?.party : ""}
                        onSelect={(data) => onhandleSelect(data, 'party')}
                    /> */}

                    <CityDropdownForTrip
                        label={"Select Party"}
                        placeholder="Select Party"
                        fetchData={fetchConsignor}
                        pageSize={20}
                        onChange={(data) => {
                            onhandleSelect(data, 'party')
                        }}
                        selectedItem={formValue?.party?.value ? formValue?.party : {}}
                        error={formError["party.label"]}
                        errorMessage={formError["party.label"]}
                        isClearOption={formValue?.party?.value ? true : false}
                        isClearHandleChange={() => {
                            onhandleSelect({}, "party"); // label: 'Assign Driver', value: ''
                        }}
                        isAddButton={true}
                        addButtonAction={(e) => buttonActionHandler(e)}
                    />
                </div>
            </CommonModal>

            {modalConfig.isOpen && <EbillExtentionModal

                {...ebillExpProps}

            />}

        </div>
    )
}

export default AddLrModal
